<template>
<div v-bind:class="{'info-flag':(infoFlag || streetFlag)}">
    <slot class="draw-advise" name="advise"></slot>
    <div id="map" class="kernel-map" style=" position:absolute; z-index:2"></div>
</div>
</template>

<style>
.kernel-map {
  border: 0;
  height: calc(100vh - 51px);
  position: relative;
  width:100%;
  z-index: 1;
  cursor:default;
}
.info-flag .kernel-map {
  cursor: crosshair !important;
}

.draw-advise{
  height: 8rem;
  width: 8em;
}

.leaflet-control-filelayer  {
  visibility: hidden;
}
</style>

<script>

import {FileLoader, FileLayerLoad} from './FileLoader';
import {Loader} from '@googlemaps/js-api-loader';
import EventBus from '../EventBus.vue';

export default {
  name: 'MapModule',
  props: ['infoFlag', 'streetFlag', 'user_id'],
  data () {
    return {
      kmzLoadedLayer: null,
      kmzLoadedFilename: null,
      m: null
    };
  },
  computed: {
  },
  mounted: function () {
    this.initGoogleMapsApi();
    // this.initMap();
  },
  watch: {
    user_id: function () {
      this.initMap();
    }
  },
  methods: {

    removeKmzLayer: function () {
      if (this.kmzLoadedLayer) {
        this.m.removeLayer(this.kmzLoadedLayer);
      }
    },
    addKmzLayer: function () {
      if (this.kmzLoadedLayer) {
        this.m.addLayer(this.kmzLoadedLayer);
      }
    },

    initGoogleMapsApi: function () {
      const loader = new Loader({
        apiKey: process.env.GOOGLE_MAPS_API_KEY,
        libraries: ['places']
      });

      loader.load().then(async () => {
        console.log('API GoogleMaps Loaded Successfully!');
        EventBus.$emit('google-maps-api-loaded');
        this.initMap();
      });
    },

    initMap: function () {
      if (this.user_id) {
        this.$http.get('vistas_mapa/', {params: {usuario: this.user_id}}).then(result => {
          var vista = {zoom: 6, y: 41.3897584, x: 2.1455073};
          if (result.data.count > 0) {
            vista = result.data.results[0];
          }

          this.m = self.L.map('map', {maxZoom: 22, zoomControl: false}).setView([vista.y, vista.x], vista.zoom);

          var polygonDrawer = new self.L.Draw.Polygon(this.m, {showArea: true});
          // var polylineDistance = new self.L.Draw.Polyline(m, {showLength: true, allowIntersection: false})

          // var l = self.L.tileLayer('https://{s}.tile.openstreetmap.se/hydda/full/{z}/{x}/{y}.png', {
          //   attribution: '',
          //   maxZoom: 19
          // })

          var l = self.L.gridLayer.googleMutant({
            type: 'roadmap',
            styles: [
              {featureType: 'poi', stylers: [{visibility: 'off'}]}
            ]
          });
          var lGoogle = self.L.gridLayer.googleMutant({
            type: 'roadmap',
            styles: [
              {featureType: 'poi', stylers: [{visibility: 'on'}]}
            ]
          });
          //  Si solo comercios -> {featureType: 'poi.business', stylers: [{visibility: 'off'}]}
          // var l = self.L.tileLayer('http://{s}.google.com/vt/lyrs=r&x={x}&y={y}&z={z}', {
          //   maxZoom: 19,
          //   subdomains: ['mt0', 'mt1', 'mt2', 'mt3']
          // })
          this.m.addLayer(l);

          // Vista satelite
          var l2 = self.L.gridLayer.googleMutant({
            type: 'hybrid',
            styles: [
              {featureType: 'poi', stylers: [{visibility: 'off'}]}
            ]
          });
          var l2Google = self.L.gridLayer.googleMutant({
            type: 'hybrid',
            styles: [
              {featureType: 'poi', stylers: [{visibility: 'on'}]}
            ]
          });

          var control = self.L.control.layers({'Vista estándar': l, 'Vista satélite': l2}, {}, {autoZIndex: true});
          control.addTo(this.m);

          var controlDistance = self.L.control.measure({'idButton': 'button-distance'});
          controlDistance.addTo(this.m);

          /* LOAD */

          self.L.FileLayer = {};

          self.L.FileLayer.FileLoader = FileLoader(self.L);

          self.L.FileLayer.fileLoader = function (map, options) {
            return new self.L.FileLayer.FileLoader(map, options);
          };

          self.L.Control.FileLayerLoad = FileLayerLoad(self.L);

          self.L.Control.fileLayerLoad = function (options) {
            return new self.L.Control.FileLayerLoad(options);
          };

          let ctrl = self.L.Control.fileLayerLoad({
            // Allows you to use a customized version of L.geoJson.
            // For example if you are using the Proj4Leaflet leaflet plugin,
            // you can pass L.Proj.geoJson and load the files into the
            // L.Proj.GeoJson instead of the L.geoJson.
            layer: self.L.geoJson,
            // See http://leafletjs.com/reference.html#geojson-options
            layerOptions: {style: {color: 'red'}},
            // Add to map after loading (default: true) ?
            addToMap: false,
            // File size limit in kb (default: 1024) ?
            fileSizeLimit: 1024 * 500,
            // Restrict accepted file formats (default: .geojson, .json, .kml, and .gpx) ?
            formats: [
              '.kmz',
              '.kml'
            ]
          }).addTo(this.m);

          let that = this;
          ctrl.loader.on('data:loaded', function (e) {
            that.removeKmzLayer();

            console.log(e.filename);
            // debugger
            // ctrlmap.addOverlay(e.layer, e.filename)

            let markerProperties = {
              radius: 8,
              fillColor: '#ff7800',
              color: '#000',
              weight: 1,
              opacity: 1,
              fillOpacity: 0.8
            };

            let layerWithBindings = self.L.geoJson(e.layer.toGeoJSON(), {
              onEachFeature: function (feature, layer) {
                // set icon to a new DivIcon
                if (feature.properties && feature.properties.name) {
                  layer.bindPopup(feature.properties.name);
                }
              },
              pointToLayer: function (feature, latlng) {
                return self.L.circleMarker(latlng, markerProperties);
              }
            });

            that.kmzLoadedLayer = layerWithBindings;

            that.kmzLoadedFilename = e.filename;

            alert('Datos cargados con éxito');

            that.addKmzLayer();

            that.$parent.$children[0].kmz = true;
            that.$parent.$children[0].kmzFilename = e.filename;

            // ctrlmap
            // map
          });

          /* LOAD */

          this.$parent.setMap(this.m, [l, l2], [lGoogle, l2Google], control, polygonDrawer);

          // this.$http.get('filtros_usuarios/', {params: {usuario: this.user_id}}).then(
          //   fcomerciales => {
          //     this.$http.get('filtros_caldera/', {params: {usuario: this.user_id}}).then(
          //       fcalderas => {
          //         var filtroscaldera = response[1].data.results[0]
          //         var filtroscomerciales = response[0].data.results[0]

          //         setTimeout(() => {
          //           this.$parent.applyFilter(filtroscomerciales, filtroscaldera)
          //         }, 5000)
          //         this.$parent.setMap(this.m, [l, l2], [lGoogle, l2Google], control) // Needs permissions
          //         this.$parent.setDrawer(polygonDrawer)
          //       })
          //   })
          // this.$parent.setDistanceDrawer(polylineDistance)
        });
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Modules/Map/Map.vue